exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paypal-button { \r\n\tfont-family: Roboto;\r\n\tfont-style: normal;\r\n\tfont-weight: 500;\r\n\tfont-size: 22px;\r\n\tline-height: 28px;\r\n\tcolor: #FFFFFF;\r\n\tbackground: #2F79EB;\r\n\tborder-radius: 10px;\r\n\tpadding: 14px 22px;\r\n\tborder: 0 none; \r\n}\r\n.plan-grey { background: #767676; color: #fff;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/paypal/paypal.component.css
// module id = ../../../../../src/app/paypal/paypal.component.css
// module chunks = main